"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectMenuDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = _interopRequireDefault(require("uuid"));

var _PopperMenu = _interopRequireDefault(require("../../modules/PopperMenu"));

var _Icons = require("../../foundation/Icons");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SelectMenu = function SelectMenu(props) {
  var disabled = props.disabled,
      classNames = props.classNames,
      size = props.size,
      iconSize = props.iconSize,
      children = props.children,
      label = props.label,
      id = props.id,
      NewProps = _objectWithoutProperties(props, ["disabled", "classNames", "size", "iconSize", "children", "label", "id"]);

  var _useState = (0, _react.useState)(id !== 'undefined' ? id : (0, _uuid.default)()),
      _useState2 = _slicedToArray(_useState, 1),
      InputID = _useState2[0]; // uuid was changing every re-render so storing once.


  var selectMenuClasses = (0, _classnames.default)('selectmenu-component', "selectmenu-component-".concat(size), classNames);
  var selectMenuLabelClasses = (0, _classnames.default)('selectmenu-component-label');

  var labelComponent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  var selectMenuIconClasses = (0, _classnames.default)('selectmenu-component__icon');

  switch (size) {
    case 'large':
    default:
      labelComponent = /*#__PURE__*/_react.default.createElement("div", _extends({
        className: selectMenuClasses,
        id: InputID
      }, NewProps), /*#__PURE__*/_react.default.createElement("label", {
        className: selectMenuLabelClasses,
        htmlFor: InputID
      }, label), /*#__PURE__*/_react.default.createElement(_Icons.IcoCaretDown, {
        className: selectMenuIconClasses,
        size: iconSize
      }));
      break;

    case 'medium':
      labelComponent = /*#__PURE__*/_react.default.createElement("div", _extends({
        className: selectMenuClasses,
        id: InputID
      }, NewProps), /*#__PURE__*/_react.default.createElement("label", {
        className: selectMenuLabelClasses,
        htmlFor: InputID
      }, label), /*#__PURE__*/_react.default.createElement(_Icons.IcoEllipsisV, {
        className: selectMenuIconClasses,
        size: iconSize
      }));
      break;

    case 'small':
      labelComponent = /*#__PURE__*/_react.default.createElement("div", _extends({
        className: selectMenuClasses
      }, NewProps), /*#__PURE__*/_react.default.createElement(_Icons.IcoEllipsisV, {
        className: selectMenuIconClasses,
        size: iconSize
      }));
      break;
  }

  return /*#__PURE__*/_react.default.createElement(_PopperMenu.default, {
    menuPlacement: "bottom",
    arrow: true,
    disabled: disabled,
    referenceElement: labelComponent
  }, children);
};

SelectMenu.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any.isRequired,
  size: _propTypes.default.oneOf(['large', 'medium', 'small']).isRequired,
  iconSize: _propTypes.default.any.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.arrayOf(_propTypes.default.any)]),
  label: _propTypes.default.string.isRequired,
  id: _propTypes.default.string
};
var SelectMenuDefaultProps = {
  disabled: false,
  classNames: {},
  size: 'large',
  iconSize: '3x'
};
exports.SelectMenuDefaultProps = SelectMenuDefaultProps;
SelectMenu.defaultProps = SelectMenuDefaultProps;
var _default = SelectMenu;
exports.default = _default;